<template>
    <sub-header />
</template>

<script>
    import SubHeader from 'components/Header/White/SubHeader'

    export default {
        components: {
          SubHeader
        }
    }
</script>
